import { Observable } from 'rxjs';
import api from '@Utils/api';
import { AjaxResponse } from 'rxjs/ajax';
export class enhancedTermAndCondition {
	public static getEnahancedTermsAndCondition(lang: string, isTCPlan: boolean): Observable<AjaxResponse> {
		return api.wcm.getEnahancedTermsAndCondition(lang, isTCPlan).call();
	}
}
